<template lang="html">
  <div class="button" @click="callback()">
    <div class="line" />
    <div class="line" />
  </div>
</template>

<script>
export default {
  props: ['callback']
}
</script>

<style lang="css" scoped>
  .button {
    margin: auto;
    width: 65px;
    cursor: pointer;
    padding: 10px 0;
  }
  .line {
    background-color: white;
    width: 100%;
    height: 3px;
    border-radius: 15px;
    margin: 7.5px 0;
  }
</style>
